export default __webpack_public_path__ + "media/images/react_icons/quotation_marks_light-b54f3ecbce5ff157bbf82037585bdd05.svg";